import defaultTheme from "../defaultTheme"
import paywellTheme from "../paywellTheme"
import pay2dayTheme from "../pay2dayTheme"

const themeSelector = (companyName: string) => {
  switch (companyName) {
    case "paywell":
      return paywellTheme
    case "pay2day":
      return pay2dayTheme
    default:
      return defaultTheme
  }
}

export default themeSelector
